export const COMPLAINT_CATEGORIES = [
  {
    value: 'roads',
    label_en: 'Roads and Traffic',
    label_mr: 'रस्ते-वाहतूक',
    icon: 'car-outline',
    issues: [
      { code: 'potholes', en: 'Potholes and uneven road surfaces', mr: 'खड्डे आणि डोंगराळ रस्ते' },
      { code: 'encroachments', en: 'Encroachments narrowing roads', mr: 'अतिक्रमणामुळे रस्ते अरुंद' },
      { code: 'traffic_congestion', en: 'Traffic congestion', mr: 'ट्रॅफिक जॅम' },
      { code: 'poor_drainage', en: 'Waterlogging during monsoon', mr: 'पावसाळ्यात पाणी साचणे' },
      { code: 'no_footpaths', en: 'Lack of footpaths and zebra crossings', mr: 'फुटपाथ आणि झेब्रा क्रॉसिंग नाहीत' },
      { code: 'bad_design', en: 'Faulty road engineering', mr: 'रस्त्यांचा खराब डिझाइन' },
      { code: 'lane_marking', en: 'Faded lane markings/signals', mr: 'लेन मार्किंग फिकट किंवा सिग्नल खराब' },
      { code: 'black_spots', en: 'Accident black spots', mr: 'अपघाताचे ब्लॅक स्पॉट्स' },
      { code: 'illegal_parking', en: 'Illegal parking', mr: 'चुकीचे पार्किंग' },
      { code: 'street_lights', en: 'No street lights', mr: 'रस्त्यावर दिवे नाहीत' },
    ],
  },

  {
    value: 'waste',
    label_en: 'Waste Management',
    label_mr: 'कचरा साफसफाई',
    icon: 'trash-outline',
    issues: [
      { code: 'garbage_collection', en: 'Irregular garbage collection', mr: 'कचरा वेळेवर न उचलणे' },
      { code: 'no_segregation', en: 'No waste segregation', mr: 'कचरा वेगळा केला जात नाही' },
      { code: 'overflowing_bins', en: 'Overflowing bins', mr: 'बिन फुललेले' },
      { code: 'open_burning', en: 'Open burning of waste', mr: 'कचरा जाळणे' },
      { code: 'construction_debris', en: 'Improper disposal of debris', mr: 'बांधकामाचा कचरा इकडेतिकडे' },
      { code: 'no_collection_slums', en: 'No doorstep collection in slums', mr: 'झोपडपट्टीत दारात कचरा उचलत नाहीत' },
      { code: 'no_recycling', en: 'No recycling facilities', mr: 'रिसायकलिंग सुविधा नाहीत' },
      { code: 'stray_animals', en: 'Stray animals in garbage', mr: 'भटके प्राणी कचऱ्यात' },
      { code: 'biomedical_waste', en: 'Biomedical waste mixing', mr: 'हॉस्पिटलचा कचरा मिसळला' },
    ],
  },

  {
    value: 'water',
    label_en: 'Water Supply',
    label_mr: 'पाणीपुरवठा',
    icon: 'water-outline',
    issues: [
      { code: 'low_pressure', en: 'Low water pressure', mr: 'पाण्याचा दाब कमी' },
      { code: 'contaminated', en: 'Contaminated water', mr: 'पाणी गंदं' },
      { code: 'pipeline_leak', en: 'Pipeline leak', mr: 'पाइप फुटणे/गळती' },
      { code: 'tanker_dependency', en: 'Dependence on tankers', mr: 'टँकरवर अवलंबून' },
      { code: 'water_theft', en: 'Unauthorized tapping', mr: 'बेकायदेशीर टॅप' },
      { code: 'billing_issue', en: 'Meter/Billing issue', mr: 'मीटर/बिल समस्या' },
      { code: 'groundwater', en: 'Groundwater depletion', mr: 'भूजल कमी होणे' },
    ],
  },

  {
    value: 'sewage',
    label_en: 'Sewage and Drainage',
    label_mr: 'सांडपाणी-नाला',
    icon: 'git-branch-outline',
    issues: [
      { code: 'overflowing_manhole', en: 'Overflowing manholes', mr: 'मॅनहोल ओसंडणे' },
      { code: 'clogged_drains', en: 'Clogged storm drains', mr: 'नाले गाळाने भरले' },
      { code: 'rain_flood', en: 'Flooding during rains', mr: 'पावसात पूर' },
      { code: 'open_nullah', en: 'Open nullahs breeding mosquitoes', mr: 'खुले नाले आणि मच्छर' },
      { code: 'no_stp', en: 'No sewage treatment plant', mr: 'सांडपाणी प्रक्रिया केंद्र नाही' },
      { code: 'toilet_maintenance', en: 'Poor public toilet maintenance', mr: 'सार्वजनिक शौचालय साफ नाही' },
    ],
  },

  {
    value: 'electricity',
    label_en: 'Power and Streetlights',
    label_mr: 'वीज-रस्त्याचे दिवे',
    icon: 'flash-outline',
    issues: [
      { code: 'power_cut', en: 'Frequent power cuts', mr: 'वारंवार वीज जाते' },
      { code: 'street_light_fault', en: 'Street light not working', mr: 'रस्त्याचा दिवा बंद' },
      { code: 'transformer_trip', en: 'Transformer overloading', mr: 'ट्रान्सफॉर्मर ट्रिप' },
      { code: 'illegal_connection', en: 'Illegal electricity tapping', mr: 'बेकायदेशीर वीज जोड' },
      { code: 'wiring_issue', en: 'Old/damaged wiring', mr: 'जुनी वायरिंग खराब' },
    ],
  },

  {
    value: 'health',
    label_en: 'Public Health and Safety',
    label_mr: 'आरोग्य-सुरक्षितता',
    icon: 'medical-outline',
    issues: [
      { code: 'stray_dogs', en: 'Stray dogs/cattle', mr: 'भटके कुत्रे/गायी' },
      { code: 'dengue', en: 'Dengue/Malaria cases', mr: 'डेंग्यू/मलेरिया' },
      { code: 'noise_pollution', en: 'Noise pollution', mr: 'ध्वनी प्रदूषण' },
      { code: 'no_cctv', en: 'No CCTV / unsafe area', mr: 'सीसीटीव्ही नाही' },
      { code: 'illegal_building', en: 'Illegal construction', mr: 'बेकायदेशीर बांधकाम' },
      { code: 'fire_risk', en: 'Fire hazard', mr: 'आग धोका' },
      { code: 'air_pollution', en: 'Air pollution', mr: 'हवा प्रदूषण' },
      { code: 'ambulance_delay', en: 'Ambulance delay', mr: 'एम्ब्युलन्स उशीर' },
    ],
  },

  {
    value: 'ambulance',
    label_en: 'Ambulance Services',
    label_mr: 'एम्ब्युलन्स सेवा',
    icon: 'car-sport-outline',
    issues: [
      { code: 'response_delay', en: 'Delayed response time', mr: 'उशीर प्रतिसाद' },
      { code: 'no_als', en: 'No advanced life support vehicle', mr: 'ALS वाहन नाही' },
      { code: 'gps_issue', en: 'GPS/Dispatch issue', mr: 'GPS समस्या' },
      { code: 'high_cost', en: 'High ambulance cost', mr: 'एम्ब्युलन्स महाग' },
      { code: 'night_unavailable', en: 'Not available at night', mr: 'रात्री उपलब्ध नाही' },
    ],
  },

  {
    value: 'voter',
    label_en: 'Voter Services',
    label_mr: 'मतदार सेवा',
    icon: 'id-card-outline',
    issues: [
      { code: 'new_voter', en: 'New voter ID registration', mr: 'नवीन वोटर आयडी नोंद' },
      { code: 'update_details', en: 'Update voter details', mr: 'माहिती अपडेट करा' },
      { code: 'address_update', en: 'Address update in voter list', mr: 'पत्ता बदल अपडेट' },
      { code: 'ghost_entries', en: 'Ghost entries in voter list', mr: 'यादीत जुनी नावं' },
      { code: 'polling_issue', en: 'Polling booth issue', mr: 'मतदान केंद्र समस्या' },
    ],
  },
];